import { Branding } from 'packages/theming/brands';

export const branding: Branding = {
  siteName: 'Our Time',
  favIconName: 'favicon-our-time',
  name: 'ourtime',
  facebookUrl: 'https://www.facebook.com/ourtimebr/',
  instagramUrl: 'https://www.instagram.com/ourtimebrasil/',
};

export default branding;
